import axios from "axios";
import React, { useState, useEffect } from "react";
import CreaEquipoImagenesTerapeuticas from "./CreaEquipos/CreaEquipoImagenesTerapeuticas";
import Cookies from "universal-cookie";
import DequipoImagenesTerapeuticas from "../../EliminaEquipos/DequipoImagenesTerapeuticas";

function EquipoImagenesTerapeuticas({ idSolicitud }) {
  const cookies = new Cookies();
  const [list, setList] = useState([]);

  const obtenerDatos = () => {
    axios({
      method: "get",
      auth: {
        username: "BasicAuth@icontec.org",
        password: "yQLzqmR7eZSuAmQZUqhY",
      },
      url:
        "https://suadesarrollo.azurewebsites.net/api/ObtenerEquipoImagenesTerapeuticasPorSolicitudId?SolicitudId=" +
        idSolicitud,
    })
      .then((response) => setList(response.data))
      .catch((error) => console.error(error));
  };

  useEffect(() => {
    obtenerDatos();
  }, []);

  const nombreRuta =
    window.location.href.split("/")[
      window.location.href.split("/").indexOf("#") + 1
    ];

  return (
    <div className="container">
      <div className="card shadow mb-4">
        <div className="card-header py-3">
          <h6 className="m-0 font-weight-bold text-primary">
            5.3. Equipo Primario de Mejoramiento de Imágenes Terapéuticas
          </h6>
        </div>

        <div className="card-body">
          {cookies.get("tipo_Usuario") == 2 &&
            nombreRuta === "ProcesoAutoevaluacion" && (
              <CreaEquipoImagenesTerapeuticas
                idSolicitud={idSolicitud}
                onSuccess={obtenerDatos}
              />
            )}

          <div className="table-responsive">
            <table className="table table-bordered" width="100%">
              <thead>
                <tr>
                  <th>Id</th>
                  <th>Nombre</th>
                  <th>Servicio</th>
                  <th>Cargo</th>
                  <th>Líder</th>
                  {nombreRuta === "ProcesoAutoevaluacion" && <th>Acciones</th>}
                </tr>
              </thead>

              <tbody>
                {list.map((item) => (
                  <tr key={item.id}>
                    <td>{item.id}</td>
                    <td>{item.nombre}</td>
                    <td>{item.servicio}</td>
                    <td>{item.cargo}</td>
                    <td>{item.lider}</td>

                    {nombreRuta === "ProcesoAutoevaluacion" && (
                      <td>
                        <DequipoImagenesTerapeuticas
                          id={item.id}
                          onSuccess={obtenerDatos}
                        />
                      </td>
                    )}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
}

export default EquipoImagenesTerapeuticas;
